import { appointmentConstants } from "../constants";

export function appointments(state = {}, action) {
  switch (action.type) {
    case appointmentConstants.GETAPPOINTMENTS_LIST_SUCCESS:
      return {
        ...state,
        appointments: action.appointments
      };
    case appointmentConstants.GETAPPOINTMENTS_LIST_REQUEST:
      return {
        ...state,
        appointments: action.appointments
      };
    case appointmentConstants.GETAPPOINTMENTS_LIST_FAILURE:
      return {
        ...state,
        appointments: action.appointments
      };
    case appointmentConstants.GETPATIENTS_LIST_SUCCESS:
      return {
        ...state,
        list: action.list
      };
    case appointmentConstants.COUNSELLOR_APPOINTMENTS_REQUEST:
    case appointmentConstants.CREATEAPPOINTMENT_REQUEST:
      return {
        ...state,
        data: action.data,
        loading:true
      };
    case appointmentConstants.COUNSELLOR_APPOINTMENTS_FAILURE:
      return {
        ...state,
        loading:false
      };
    case appointmentConstants.CREATEAPPOINTMENT_FAILURE:
      return {
        ...state,
        data: action.data,
        loading:false
      };
    case appointmentConstants.COUNSELLOR_APPOINTMENTS_SUCCESS:
    case appointmentConstants.CREATEAPPOINTMENT_SUCCESS:
      return {
        ...state,
        list: action.list,
        loading:false
      };
    case appointmentConstants.GETPATIENTS_LIST_REQUEST:
      return {
        ...state,
        list: action.list
      };
    case appointmentConstants.GETPATIENTS_LIST_FAILURE:
      return {
        ...state,
        list: action.list
      };
    case appointmentConstants.CANCELAPPOINTMENT_SUCCESS:
      return {
        ...state,
        data: action.data
      };
    case appointmentConstants.SET_COUNSELLOR_STATUS_REQUEST:
      return {
        ...state
      };
    case appointmentConstants.SET_COUNSELLOR_STATUS_FAILURE:
      return {
        ...state,
        data: action.data
      };
    case appointmentConstants.PATIENT_DETAIL_REQUEST:
      return {
        ...state
      };
    case appointmentConstants.PATIENT_DETAIL_SUCCESS:      
      return {
        ...state,
        patient_detail: action.list
      };
    case appointmentConstants.PATIENTS_LIST_REQUEST:
      return {
        ...state
      };
    case appointmentConstants.PATIENTS_LIST_SUCCESS:
      return {
        ...state,
        patients: action.patients
      };
    case appointmentConstants.PATIENTS_LIST_FAILURE:
      return {
        ...state,
        patients: action.patients
      };
    case appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_REQUEST:
    case appointmentConstants.USER_REQUEST_SESSION_REQUEST:
      return{
        ...state,
        loading:true,
      }
    case appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_SUCCESS:
    case appointmentConstants.COUNSELLOR_REQUEST_APPOINTMENTS_FAILURE:
    case appointmentConstants.USER_REQUEST_SESSION_SUCCESS:
    case appointmentConstants.USER_REQUEST_SESSION_FAILURE:
      return{
        ...state,
        loading:false,
      }
    case appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_REQUEST:
      return{
        ...state,
        loading:true,
        updateStatus:false,
      }
    case appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_FAILURE:
             return{
        ...state,
        updateStatus:false,
        loading:false,

      }

    case appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_RESET:
        return{
        ...state,
          updateStatus:false
      }

    case appointmentConstants.COUNSELLOR_UPDATEAPPOINTMENTS_SUCCESS:
      return{
        ...state,
        updateStatus:true,
        loading:false,
      }
    case appointmentConstants.GET_CALL_STATUS_SUCCESS:
      return{
        ...state,
        appointmentOptions:action.options
      }
    case appointmentConstants.GET_CALL_STATUS_FAILURE:
      return{
        ...state,
        appointmentOptions:''
      }
    case appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_REQUEST:
      return{
        loading:true
      }
    case appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_SUCCESS:
      return{
        ...state,
        loading:false
      }
    case appointmentConstants.PATIENT_REQUEST_ARRANGE_APPOINTMENTS_FAILURE:
      return{
        loading:false
      }

      
      case appointmentConstants.SESSION_CAPS_REQUEST:
      return{
        loading:true
      }
    case appointmentConstants.SESSION_CAPS_SUCCESS:
      return{
        ...state,
        session_cap_detail: action.list,
        loading: false
      }
    case appointmentConstants.SESSION_CAPS_FAILURE:
      return{
        loading:false
      }

      
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/appointment.reducer.js